export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";